import React from "react"

const EmptyCarePerson = () => {
  return <></>
}

export default EmptyCarePerson
